import { useEffect, useState } from "react";
import { CountryDisplay } from "../../features/billingInformations/models/CountryDisplay.interface";
import { listCountries, billingInformationsState } from "../../features/billingInformations/billingInformationsSlice";
import { useAppDispatch, useAppSelector } from "../redux/hooks";


export const useCountry = (): [boolean, CountryDisplay[]] => {
    const dispatch = useAppDispatch();
    const { availableCountries } = useAppSelector(billingInformationsState);

    useEffect(() => {
        if (!availableCountries.isLoading && !availableCountries.isSuccess) {
            dispatch(listCountries());
        }
    }, [dispatch, availableCountries]);

    return [availableCountries.isSuccess, availableCountries.countries]
}


export const useCountryState = (countries: CountryDisplay[]) => {
    const initialStates: any = null;

    const [states, setCountryStates] = useState(initialStates);

    const updateStateOptions = (countryCodeInput: string) => {
        const states = countries
            .find(({ countryCode }) => countryCode === countryCodeInput)?.states

        if (states) {
            setCountryStates(states.map(({ stateCode, label }) => ({ value: stateCode, label })))
        } else {
            setCountryStates(null)
        }
    }
    return [states, updateStateOptions]
}